export default __webpack_public_path__ + "static/media/editCircle.a943cea8.svg";